import { useState, ReactNode } from "react";
import clsx from "clsx";

import styles from "./Tabs.module.css";

type Tab = {
  label: string;
  content: ReactNode;
  hide?: boolean;
};

type TabsProps = {
  tabs: Tab[];
};

const Tabs: React.FC<TabsProps> = ({ tabs }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <div>
      {tabs.length > 1 && (
        <div className={styles.tabs}>
          {tabs.map(
            (tab, index) =>
              !tab.hide && (
                <button
                  key={index}
                  type="button"
                  className={clsx(
                    styles.tab,
                    activeIndex === index && styles.active
                  )}
                  onClick={() => setActiveIndex(index)}
                >
                  {tab.label}
                </button>
              )
          )}
        </div>
      )}
      <div className={styles.content}>{tabs[activeIndex]?.content}</div>
    </div>
  );
};

export default Tabs;
